/* unplugin-vue-components disabled */import script from "./Jmjl.vue?vue&type=script&lang=ts&setup=true"
export * from "./Jmjl.vue?vue&type=script&lang=ts&setup=true"

import "./Jmjl.vue?vue&type=style&index=0&id=d0c6e7e0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0c6e7e0"]])

export default __exports__